import type { SVGProps } from 'react'

const SvgEditHover = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.8335 13.8334H2.88475L11.4152 5.303L10.3639 4.25175L1.8335 12.7822V13.8334ZM0.583496 15.0834V12.263L11.5756 1.27571C11.7016 1.16126 11.8406 1.07286 11.9929 1.0105C12.1452 0.947998 12.305 0.916748 12.472 0.916748C12.6391 0.916748 12.8009 0.946401 12.9575 1.00571C13.1141 1.06501 13.2528 1.15932 13.3735 1.28862L14.3912 2.31904C14.5205 2.43973 14.6127 2.57862 14.6677 2.73571C14.7227 2.89279 14.7502 3.04987 14.7502 3.20696C14.7502 3.3746 14.7216 3.53453 14.6643 3.68675C14.6071 3.83911 14.5161 3.97828 14.3912 4.10425L3.40391 15.0834H0.583496ZM10.8804 4.78654L10.3639 4.25175L11.4152 5.303L10.8804 4.78654Z"
      fill="#0A6FCD"
    />
  </svg>
)

export default SvgEditHover
